module.exports = __webpack_public_path__ + "img/HM.805dc060.svg";